import httpClient from './httpClient';

const plameConfiguracionService = {
  // Obtener todas las configuraciones con filtros opcionales
  obtenerConfiguraciones: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Agregar parámetros de filtro si existen
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });

      const url = queryParams.toString() 
        ? `/plame-configuraciones?${queryParams.toString()}`
        : '/plame-configuraciones';

      const response = await httpClient.get(url);
      return response.data;
    } catch (error) {
      console.error('Error al obtener configuraciones PLAME:', error);
      throw error;
    }
  },

  // Obtener una configuración específica por ID
  obtenerConfiguracion: async (id) => {
    try {
      const response = await httpClient.get(`/plame-configuraciones/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener configuración PLAME:', error);
      throw error;
    }
  },

  // Actualizar una configuración existente
  actualizarConfiguracion: async (id, datos) => {
    try {
      const response = await httpClient.put(`/plame-configuraciones/${id}`, datos);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar configuración PLAME:', error);
      throw error;
    }
  },

  // Actualizar múltiples configuraciones
  actualizarConfiguracionesBatch: async (configuraciones) => {
    try {
      const response = await httpClient.put('/plame-configuraciones/batch/update', {
        configuraciones
      });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar configuraciones en lote:', error);
      throw error;
    }
  },

  // Buscar configuraciones
  buscarConfiguraciones: async (termino, filtros = {}) => {
    try {
      const params = { 
        search: termino,
        ...filtros
      };
      
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });

      const response = await httpClient.get(`/plame-configuraciones/search?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error al buscar configuraciones PLAME:', error);
      throw error;
    }
  },

  // Obtener estadísticas de configuraciones
  obtenerEstadisticas: async () => {
    try {
      const response = await httpClient.get('/plame-configuraciones/stats');
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas PLAME:', error);
      throw error;
    }
  },

  // Obtener todas las clasificaciones
  obtenerClasificaciones: async () => {
    try {
      const response = await httpClient.get('/plame-configuraciones/clasificaciones');
      return response.data;
    } catch (error) {
      console.error('Error al obtener clasificaciones PLAME:', error);
      throw error;
    }
  },

  // Obtener configuraciones específicas para tareos (clasificación_id = 21)
  obtenerConfiguracionesTareos: async () => {
    try {
      const response = await httpClient.get('/plame-configuraciones/tareos');
      return response.data;
    } catch (error) {
      console.error('Error al obtener configuraciones de tareos:', error);
      throw error;
    }
  }
};

export default plameConfiguracionService; 